import { useEffect } from "react";
export function useContextWarning(context, contextName) {
    useEffect(() => {
        if (!context) {
            console.warn(`Not inside <${contextName} />.\nDid you forget to wrap your app or map in <${contextName} />?`);
        }
    }, [context]);
}
